<template>
  <div>
    <div class="text-big">
      <b-badge variant="dark" :title="this.$gettext('Scheduled')" v-b-tooltip class="mr-1">{{order.shippings_amount}}</b-badge>
      <b-badge :variant="releasedBg" :title="this.$gettext('Released')" v-b-tooltip class="mr-1">{{releasedShippings.length}}</b-badge>
      <b-badge :variant="deliveredBg" :title="this.$gettext('Delivered')" v-b-tooltip >{{deliveredShippings.length}}</b-badge>
    </div>
    <div class="text-center">
      <b-badge v-if="shippings.length > 0" role="link" v-b-modal="'modalOrderShippingsX' + order.id">View Shipments</b-badge>
    </div>
    <b-modal v-if="shippings.length > 0" size="xl" :id="'modalOrderShippingsX' + order.id" :ref="'modalOrderShippingsX' + order.id" hide-footer>
      <template #modal-title>
        <translate>Order Shipments</translate>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <api-list type="shippingsInOrder" :model="models.shippingsInOrder" :title="''" :prePerPage="10" :preFilters="[['shipping_order_id', 'eq', order.id]]" inModal filterOnMount hideFilters />
    </b-modal>
  </div>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'ShippingOrdersListItemShippingsAmount',
  components: {
    ApiList
  },
  props: {
    order: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  computed: {
    shippings() {
      const companyId = this.$store.getters.profile && this.$store.getters.profile.company_id
      return (this.order.shippings || []).filter(x => x.courier_company_id === companyId)
    },
    releasedShippings() {
      return this.shippings.filter(x => x.status !== 'CANCELED')
    },
    deliveredShippings() {
      return this.shippings.filter(x => x.status === 'DELIVERED')
    },
    releasedBg() {
      return this.order.shippings_amount && this.shippings.length === 0 ? 'warning' : 'success'
    },
    deliveredBg() {
      if (this.releasedBg === 'warning' && this.deliveredShippings.length === 0) {
        return 'warning'
      }
      return this.releasedBg === 'success' && this.deliveredShippings.length < this.releasedShippings.length ? 'danger' : 'success'
    }
  }
}
</script>
